import React, { useEffect, useRef, useState } from 'react'
import {
  RivenditoreCardBody,
  RivenditoreCardHead,
} from '../RivenditoreCardContent/RivenditoreCardContent'
import styles from './RivenditoreAccordionCard.module.sass'
import { ChevronDown, ChevronUp } from '@components/icons'

interface Props {
  id: string | number
  rivenditore?: any
  // onShowMapClick?: () => void
  open?: boolean
  setOpen?: (v: boolean) => void
  className?: string
}

const RivenditoreAccordionCard = (props: Props) => {
  const {
    id = undefined,
    rivenditore = undefined,
    // onShowMapClick = undefined,
    open = false,
    setOpen = undefined,
    className = '',
  } = props

  const [height, setHeight] = useState(undefined)
  const innerContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setHeight(open ? innerContentRef.current?.clientHeight : 0)
    if (open) {
      setTimeout(() => {
        setHeight(undefined)
      }, 500)
    }
  }, [open, setHeight, innerContentRef.current?.clientHeight])

  return rivenditore ? (
    <div className={`${styles.root} ${open ? styles['root--open'] : ''} ${className}`}>
      <button
        className={styles.trigger}
        aria-controls={`${id}_panel`}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <RivenditoreCardHead
          rivenditore={rivenditore}
          titleId={`${id}_label`}
          className={styles.triggerContent}
        />
        <span className={styles.arrow}>{open ? <ChevronUp /> : <ChevronDown />}</span>
      </button>
      <div
        id={`${id}_panel`}
        aria-labelledby={`${id}_label`}
        className={styles.content}
        style={{
          maxHeight: height,
        }}
      >
        <div className={styles.innerContent} ref={innerContentRef}>
          <RivenditoreCardBody
            rivenditore={rivenditore}
            // onShowMapClick={onShowMapClick}
          />
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default RivenditoreAccordionCard
